<template>
  <div class="numbers-card" @click="onSelect(card)">
    <img alt="card-background" :src="getImageUrlOrCss('back')" class="numbers-card-back" />
    <div class="numbers-card-content">
      <div class="numbers-card-icon">
        <img alt="card-icon-bg" src="@/assets/images/numbers_icon_back.png" class="numbers-card-icon-back" />
        <img alt="card-icon-content" :src="getImageUrlOrCss('icon')" :class="getImageUrlOrCss('css')" />
      </div>
      <div class="numbers-card-title">
        {{ card.title }}
      </div>
      <div :class="getImageUrlOrCss('desc_css')">
        {{ card.description }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NumberCard',
  props: {
    card: Object,
    onSelect: Function
  },
  methods: {
    getImageUrlOrCss(forWhat) {
      const { type } = this.card;
      let cardBack;
      let cardIcon;
      let cssName;
      let descCssName;
      if (type === 'porting') {
        cardBack = 'numbers_card_porting';
        cardIcon = 'numbers_icon_porting';
        cssName = 'numbers-card-icon-content porting';
        descCssName = 'numbers-card-description';
      } else if (type === 'local') {
        cardBack = 'numbers_card_local';
        cardIcon = 'numbers_icon_local';
        cssName = 'numbers-card-icon-content local';
        descCssName = 'numbers-card-description';
      } else {
        cardBack = 'numbers_card_tollfree';
        cardIcon = 'numbers_icon_tollfree';
        cssName = 'numbers-card-icon-content tollfree';
        descCssName = 'numbers-card-description tollfree';
      }

      if (forWhat === 'css') {
        return cssName;
      } else if (forWhat === 'desc_css') {
        return descCssName;
      } else {
        const images = require.context('@/assets/images', false, /\.png$/);
        return images('./' + (forWhat === 'back' ? cardBack : cardIcon) + '.png');
      }
    }
  }
};
</script>

<style scoped lang="scss">
.numbers-card {
  position: relative;
  width: 24%;
  height: 400px;
  min-height: 398px;
  background: #ffffff;
  border-radius: 17px;
  margin: 0 1.1%;
  cursor: pointer;

  &:hover {
    box-shadow: 10px 14px 30px rgba(0, 0, 0, 0.05);
    margin-bottom: 10px;
  }

  .numbers-card-back {
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
  }

  .numbers-card-content {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .numbers-card-icon {
      height: 55%;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-top: 3%;

      .numbers-card-icon-back {
        position: absolute;
        height: 100%;
      }

      .numbers-card-icon-content {
        position: absolute;

        &.porting {
          height: 45%;
        }

        &.local {
          height: 40%;
        }

        &.tollfree {
          height: 35%;
        }
      }
    }

    .numbers-card-title {
      font-weight: bold;
      font-size: 29px;
      line-height: 35px;
      letter-spacing: -0.04em;
      text-align: center;
      color: $colorTitle;
    }

    .numbers-card-description {
      font-size: 16px;
      line-height: 26px;
      text-align: center;
      color: $colorText;
      margin: 20px 11.25%;

      &.tollfree {
        margin: 20px 25%;
      }
    }
  }

  @media only screen and (max-width: 767px) {
    width: 100%;
    margin-bottom: 15px;
  }
}
</style>
